import React from 'react';
import styled from 'styled-components';
import { Button, ButtonProps } from 'antd';

export interface ButtonComponentProps extends Omit<ButtonProps, 'type'> {
    fontStyle?: ButtonFont;
    buttontype?: ButtonType;
    className?: string;
}

export enum ButtonType {
    RED = 'red',
    PURPLE = 'purple',
    SPECIAL_RED = 'specialRed',
    SPECIAL_PURPLE = 'specialPurple',
}

export enum ButtonFont {
    NORMAL = 'normal',
    BOLD = 'bold',
}

const VrButton = ({ className, ...props }: ButtonComponentProps) => {
    return <StyledButton className={className} {...props} />;
};

const borderedTypes = [ButtonType.RED, ButtonType.PURPLE];

const StyledButton = styled(Button)<ButtonComponentProps>`
    border: ${(props) =>
        !props.buttontype || borderedTypes.includes(props.buttontype)
            ? '#1px solid #ccc'
            : 'none'};
    border-radius: 5px;
    font-family: 'Work Sans', Verdana, sans-serif;
    font-weight: ${(props) =>
        props.fontStyle === ButtonFont.BOLD ? '600' : '400'};
    letter-spacing: 0.2px;
    line-height: normal;
    white-space: nowrap;

    &&.ant-btn {
        background: ${(props) => {
            if (!props.buttontype || borderedTypes.includes(props.buttontype)) {
                return 'linear-gradient(#ffffff, #f5f5f5)';
            }
            if (props.buttontype === ButtonType.SPECIAL_PURPLE) {
                return 'linear-gradient(30deg, #6a29ff, #b029ff)';
            }
            return 'linear-gradient(45deg, #c80e0e, #c5561b)';
        }};
        color: ${(props) => {
            switch (props.buttontype) {
                case ButtonType.SPECIAL_RED:
                    return 'white';
                case ButtonType.SPECIAL_PURPLE:
                    return 'white';
                case ButtonType.PURPLE:
                    return '#b029ff';
                case ButtonType.RED:
                    return '#c80e0e';

                default:
                    return 'black';
            }
        }};
    }
`;

export default VrButton;
